export default function TechnologiesusedTile({ technologiesIcons, names }) {
  return (
    <div
      className="boxShadow"
      style={{
        margin: "0 20px",
        width: "80%",
        height: "100px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
      }}
    >
      {technologiesIcons &&
        technologiesIcons.map((icon, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <img
              src={icon}
              alt={`Technology Icon ${index + 1}`}
              style={{
                width: "40px",
                height: "40px",
                objectFit: "contain",
              }}
            />
            <p style={{ margin: "0", fontSize: "12px", textAlign: "center" }}>
              {names && names[index]}
            </p>
          </div>
        ))}
    </div>
  );
}
